module.exports = "\n<app-packagelist *ngIf=\"!postId\" [myPackage]=userData></app-packagelist>\n<app-packagedata *ngIf=\"postId\" [myPackageSeriesId]=postId></app-packagedata>"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/mypackages/mypackages.component.html
// module id = ../../../../../src/app/home/mypackages/mypackages.component.html
// module chunks = common